
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexio10jYmnW0XvbBbwqv0k4L4d2VZpTuo7nEl379kFHn4Meta } from "/root/workspace/__flow_work/__flow_builds/d4099d0b-ea7f-40f7-9d4a-69741bb03d6e/workspace/soho-store-web_yhIy/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93W_d43fak980whB_YR3wBl3v_4_p_45HNDzjpePiJOf5o0Meta } from "/root/workspace/__flow_work/__flow_builds/d4099d0b-ea7f-40f7-9d4a-69741bb03d6e/workspace/soho-store-web_yhIy/pages/[...slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/root/workspace/__flow_work/__flow_builds/d4099d0b-ea7f-40f7-9d4a-69741bb03d6e/workspace/soho-store-web_yhIy/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/root/workspace/__flow_work/__flow_builds/d4099d0b-ea7f-40f7-9d4a-69741bb03d6e/workspace/soho-store-web_yhIy/pages/[...slug].vue")
  }
]